<template>
  <v-app class="main-container">
    <v-main>
      <v-toolbar class="main">
        <v-spacer></v-spacer>
        <div class="main-menu">
          <div style="margin-top: -5px">
            <a :href="appUrl">
              <img :src="$t('app.logoUrl')" style="width: 240px" />
            </a>
          </div>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn v-if="!loggedIn()" text to="/register/member">
              <div
                :class="currentRouteName.startsWith('/register/member') ? 'button-style-underlined' : 'button-style'"
              >
                {{ $t('app.navigation.signUp') }}
              </div>
            </v-btn>
            <v-btn v-if="!isProfessional()" text :to="findRoute">
              <div :class="onFindPage ? 'button-style-underlined' : 'button-style'">
                {{ $t('app.navigation.searchOrMatchProfessional') }}
              </div>
            </v-btn>

            <v-btn v-if="!loggedIn()" text to="/register/professional">
              <div
                :class="
                  currentRouteName.startsWith('/register/professional') ? 'button-style-underlined' : 'button-style'
                "
              >
                {{ $t('app.navigation.joinAsProfessional') }}
              </div>
            </v-btn>
            <v-btn v-if="!loggedIn()" text href="/how-it-works">
              <div class="button-style">
                {{ $t('app.navigation.howItWorks') }}
              </div>
            </v-btn>

            <v-btn v-if="isAdmin()" text to="/admin">
              <div :class="currentRouteName.startsWith('/admin') ? 'button-style-underlined' : 'button-style'">
                {{ $t('app.navigation.admin') }}
              </div>
            </v-btn>
            <v-btn v-if="loggedIn()" text to="/appointment/list">
              <div :class="currentRouteName.startsWith('/appointment') ? 'button-style-underlined' : 'button-style'">
                {{ $t('app.navigation.appointments') }}
              </div>
            </v-btn>
            <v-btn v-if="loggedIn()" text to="/chats">
              <div :class="currentRouteName.startsWith('/chat') ? 'button-style-underlined' : 'button-style'">
                <v-badge
                  v-if="chatNotifications > 0"
                  color="red"
                  :content="chatNotifications"
                  :value="chatNotifications"
                >
                  {{ $t('app.navigation.chats') }}
                </v-badge>
                <div v-if="!chatNotifications">
                  {{ $t('app.navigation.chats') }}
                </div>
              </div>
            </v-btn>
            <v-btn v-if="loggedIn()" text :to="isProfessional() ? '/user/' + getUsername() : '/profile/member'">
              <div
                :class="
                  currentRouteName.startsWith('/profile/member') || currentRouteName.startsWith('/user')
                    ? 'button-style-underlined'
                    : 'button-style'
                "
              >
                {{ isProfessional() ? $t('app.navigation.myProfile') : $t('app.navigation.myFilters') }}
              </div>
            </v-btn>
            <v-btn v-if="loggedIn()" text to="/products">
              <div :class="currentRouteName.startsWith('/products') ? 'button-style-underlined' : 'button-style'">
                {{ $t('app.navigation.products') }}
              </div>
            </v-btn>
            <v-btn text :to="loggedIn() ? '/settings' : '/login'">
              <div :class="currentRouteName.startsWith('/log') ? 'button-style-underlined' : 'button-style'">
                {{ loggedIn() ? $t('app.navigation.settings') : $t('app.navigation.login') }}
              </div>
            </v-btn>
          </v-toolbar-items>
        </div>

        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="hidden-md-and-up" :ripple="false" icon text v-bind="attrs" v-on="on">
              <v-badge color="red" :content="menuNotifications" :value="menuNotifications">
                <img id="image-6-6" alt="" src="/Open.svg" class="ct-image icon-open" />
              </v-badge>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-if="!loggedIn()" to="/register/member">
              <v-list-item-title>{{ $t('app.navigation.signUp') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isProfessional()" to="/search">
              <v-list-item-title>{{ $t('app.navigation.searchProfessional') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isProfessional()" to="/match">
              <v-list-item-title>{{ $t('app.navigation.matchProfessional') }}</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="!loggedIn()" to="/register/professional">
              <v-list-item-title>{{ $t('app.navigation.joinAsProfessional') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!loggedIn()" href="/how-it-works">
              <v-list-item-title>{{ $t('app.navigation.howItWorks') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isAdmin()" to="/admin">
              <v-list-item-title>{{ $t('app.navigation.admin') }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/appointment/list" v-if="loggedIn()">
              <v-list-item-title>{{ $t('app.navigation.appointments') }}</v-list-item-title>
            </v-list-item>
            <v-list-item to="/chats" v-if="loggedIn()">
              <v-list-item-title>
                <v-badge
                  v-if="chatNotifications > 0"
                  color="red"
                  :content="chatNotifications"
                  :value="chatNotifications"
                >
                  {{ $t('app.navigation.chats') }}
                </v-badge>
                <div v-if="chatNotifications == 0">
                  {{ $t('app.navigation.chats') }}
                </div>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="loggedIn()" :to="isProfessional() ? '/user/' + getUsername() : '/profile/member'">
              <v-list-item-title>
                {{
                  isProfessional() ? $t('app.navigation.myProfile') : $t('app.navigation.myFilters')
                }}</v-list-item-title
              >
            </v-list-item>
            <v-list-item v-if="loggedIn()" to="/products">
              <v-list-item-title>{{ $t('app.navigation.products') }}</v-list-item-title>
            </v-list-item>
            <v-list-item :to="loggedIn() ? '/settings' : '/login'">
              <v-list-item-title>{{
                loggedIn() ? $t('app.navigation.settings') : $t('app.navigation.login')
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>

      <!-- Desktop sub-bar: Search / Match Professional (mobile uses the hamburger menu) -->
      <div v-if="onFindPage && !isProfessional()" class="sub-nav hidden-sm-and-down">
        <v-btn text to="/search">
          <div :class="currentRouteName.startsWith('/search') ? 'button-style-underlined' : 'button-style'">
            {{ $t('app.navigation.searchProfessional') }}
          </div>
        </v-btn>
        <v-btn text to="/match">
          <div :class="currentRouteName.startsWith('/match') ? 'button-style-underlined' : 'button-style'">
            {{ $t('app.navigation.matchProfessional') }}
          </div>
        </v-btn>
      </div>

      <keep-alive include="Search">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>

      <!-- Footer -->
      <footer class="app-footer">
        <div class="footer-top">
          <div class="footer-logo">
            <a :href="appUrl">
              <img :src="$t('app.logoUrl')" alt="FourWordz" />
            </a>
          </div>
        </div>

        <div class="footer-content">
          <div class="footer-section">
            <ul>
              <li v-for="(link, index) in aboutLinks" :key="index">
                <a :href="link.url">{{ link.label }}</a>
              </li>
            </ul>
          </div>

          <div class="footer-section">
            <ul>
              <li v-for="(link, index) in getStartedLinks" :key="index">
                <a :href="link.url">{{ link.label }}</a>
              </li>
            </ul>
          </div>

          <div class="footer-section">
            <h3>{{ $t('app.footer.socialMedia.title') }}</h3>
            <ul class="social-links-list">
              <li>
                <a :href="$t('app.footer.socialMedia.facebook')" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a :href="$t('app.footer.socialMedia.instagram')" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a :href="$t('app.footer.socialMedia.twitter')" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a :href="$t('app.footer.socialMedia.linkedin')" target="_blank" rel="noopener noreferrer">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-bottom">
          <div class="footer-legal">
            <!-- <a :href="$t('app.footer.legal.roadmapUrl')">{{ $t('app.footer.legal.roadmap') }}</a> -->
            <a :href="$t('app.footer.legal.privacyPolicyUrl')">{{ $t('app.footer.legal.privacyPolicy') }}</a>
            <a :href="$t('app.footer.legal.termsOfUseUrl')">{{ $t('app.footer.legal.termsOfUse') }}</a>
            <a :href="$t('app.footer.legal.cookiePolicyUrl')">{{ $t('app.footer.legal.cookiePolicy') }}</a>
            <a :href="$t('app.footer.legal.disclaimerUrl')">{{ $t('app.footer.legal.disclaimer') }}</a>
          </div>
          <div class="footer-copyright">
            <p>{{ $t('app.footer.copyright') }}</p>
          </div>
        </div>
      </footer>
    </v-main>
  </v-app>
</template>

<script>
import loginStore from '@/util/loginStore';
import notificationStore from '@/sockets/notificationStore';

export default {
  name: 'App',

  data: () => ({
    chatNotifications: 0,
    menuNotifications: 0,
    appUrl: '/',
    currentYear: new Date().getFullYear(),
    findRoute: '/search' // where the desktop "Search or Match Professional" header item lands
  }),

  computed: {
    grouped() {
      return notificationStore.grouped;
    },
    currentRouteName() {
      return this.$route.path;
    },
    onFindPage() {
      const p = this.currentRouteName;
      return p.startsWith('/search') || p.startsWith('/match');
    },
    aboutLinks() {
      return this.$t('app.footer.aboutSection.links');
    },
    getStartedLinks() {
      return this.$t('app.footer.getStartedSection.links');
    }
  },

  methods: {
    loggedIn() {
      return loginStore.loggedIn;
    },
    isAdmin() {
      return loginStore.isAdmin;
    },
    getUsername() {
      return loginStore.username;
    },
    isProfessional() {
      return loginStore.isProfessional;
    }
  },

  watch: {
    grouped(notifications) {
      let chatNotifications = 0;
      for (let index = 0; index < notifications.length; index++) {
        const notification = notifications[index];
        if (notification.notificationType == 'chat') {
          chatNotifications++;
        }
      }
      this.chatNotifications = chatNotifications;
      this.menuNotifications = chatNotifications;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/_variables.scss';

/* ADD THIS TO YOUR index.html IN THE <head> SECTION:
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
*/

.main-container {
  font-family: 'Nunito', sans-serif !important;
}

.main-menu {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.main {
  padding: 20px !important;
  height: auto !important;
}

.sub-nav {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 4px 16px;
  background: $bg-white;
  border-bottom: 1px solid $border;
}

.hidden-sm-and-down {
  height: auto !important;
}

.menu {
  font-size: 16px !important;
  text-transform: inherit !important;
}

.v-btn {
  font-size: 16px !important;
  text-transform: inherit !important;
  font-family: 'Nunito' !important;
  letter-spacing: unset !important;
  line-height: 1.6 !important;
  font-weight: 400 !important;
  -webkit-font-smoothing: auto !important;

  &:before {
    opacity: 0 !important;
    color: #000000 !important;
  }
}

.button-style {
  border-bottom: transparent 2px solid !important;
  padding-bottom: 8px !important;

  &:hover {
    border-bottom: $text-dark 2px solid !important;
  }
}

.button-style-underlined {
  border-bottom: $text-dark 2px solid !important;
  padding-bottom: 8px !important;
}

.v-ripple__container {
  opacity: 0 !important;
  height: auto !important;
}

.v-toolbar__content {
  height: auto !important;
  padding: 10px 16px 4px 0px !important;
}

.v-application {
  .success-green {
    background-color: $brand-color !important;
    color: $bg-white !important;
    font-weight: 700 !important;
    letter-spacing: 1.5px !important;
  }

  .success-red {
    background-color: #c94646 !important;
    color: $bg-white !important;
    font-weight: 700 !important;
    letter-spacing: 1.5px !important;
  }

  .success-gray {
    background-color: rgba(0, 0, 0, 0.12) !important;
    color: $bg-white !important;
    font-weight: 700 !important;
    letter-spacing: 1.5px !important;
  }

  .main-btn {
    padding-top: 10px;
    padding-right: 20px;
    padding-bottom: 10px;
    padding-left: 20px;
    text-align: left;
    font-weight: 700;
    border-radius: 20px;
    flex-direction: unset;
    display: inline-block;
    letter-spacing: 1.5px;
  }
}

.greenText {
  color: $brand-color !important;
}

.v-btn__content {
  height: 100%;
}

/* Footer Styles */
.app-footer {
  background: $brand-color;
  color: $bg-white;
  margin-top: 5rem;
  margin-bottom: 0;
  padding: 4rem 2rem 0;
  font-family: 'Nunito', sans-serif;
  border-top: 1px solid $border;
}

.footer-top {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-logo {
  display: inline-block;

  img {
    width: 150px;
    height: auto;
    display: block;
  }

  a {
    text-decoration: none;
    display: inline-block;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.8;
    }
  }
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4rem;
  margin-bottom: 4rem;
}

.footer-section {
  h3 {
    font-size: 0.95rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: $bg-white;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    margin-bottom: 0.75rem;
    line-height: 1.8;
  }

  a {
    color: $bg-white !important;
    text-decoration: underline;
    font-size: 1.1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    display: inline-block;

    &:hover {
      color: $bg-white !important;
      padding-left: 4px;
      opacity: 0.8;
    }
  }
}

.social-links-list {
  list-style: none;
  padding: 0;
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;

  li {
    margin-bottom: 0;
  }

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: $bg-white;
    color: $brand-color !important;
    border-radius: 50%;
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    padding: 0 !important;

    i {
      color: $brand-color !important;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
      transform: translateY(-3px);
      box-shadow: 0 4px 12px rgba(255, 255, 255, 0.25);
      color: $brand-color !important;
    }
  }
}

.footer-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
  padding-bottom: 1rem;
  border-top: 4px solid rgba(255, 255, 255, 0.1);
  gap: 0.5rem;
  background-color: $brand-dark;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-bottom: 0;
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;

  a {
    color: $bg-white !important;
    text-decoration: underline;
    font-size: 1rem;
    font-weight: 600;
    transition: color 0.3s ease;
    padding: 0 !important;

    &:hover {
      color: $bg-white !important;
      opacity: 0.8;
    }
  }
}

.footer-copyright {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: $bg-white;
  letter-spacing: 0.3px;

  p {
    margin: 0;
  }
}

/* Mobile Footer Styles */
@media (max-width: 768px) {
  .app-footer {
    padding: 2.5rem 1.5rem 1.5rem;
  }

  .footer-top {
    margin-bottom: 1rem;
    padding-bottom: 1.5rem;

    img {
      width: 120px;
    }
  }

  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .footer-section h3 {
    font-size: 0.85rem;
    margin-bottom: 1rem;
  }

  .footer-section a,
  .footer-section router-link {
    font-size: 0.85rem;
  }

  .footer-bottom {
    padding-top: 1.5rem;
    gap: 1rem;
  }

  .footer-legal {
    gap: 1.2rem;

    a {
      font-size: 0.75rem;
    }
  }

  .footer-copyright {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .app-footer {
    padding: 2rem 1rem 1rem;
  }

  .footer-top {
    margin-bottom: 1rem;

    img {
      width: 100px;
    }
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin-bottom: 2rem;
  }

  .footer-section h3 {
    font-size: 0.8rem;
  }

  .footer-section a,
  .footer-section router-link {
    font-size: 0.8rem;
  }

  .social-links-list {
    gap: 0.75rem;

    a {
      width: 35px;
      height: 35px;
      font-size: 0.85rem;
    }
  }

  .footer-legal {
    flex-direction: column;
    gap: 0.75rem;

    a {
      font-size: 0.7rem;
    }
  }

  .footer-copyright {
    font-size: 0.7rem;
  }
}
</style>
